import { render, staticRenderFns } from "./DeletedModels.vue?vue&type=template&id=97da60ac&"
import script from "./DeletedModels.vue?vue&type=script&lang=js&"
export * from "./DeletedModels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports